
import { defineComponent } from 'vue'
import { Endpoints } from '@octokit/types'
import axios from 'axios'

export default defineComponent({
  props: {
    username: String,
  },
  data() {
    return {
      user: {} as Endpoints['GET /users/{username}']['response']['data'],
      orgs: {} as Endpoints['GET /users/{username}/orgs']['response'],
    }
  },
  async mounted() {
    let token: string
    this.$store.getters.getToken
      ? (token = this.$store.getters.getToken)
      : (token = process.env.VUE_APP_TOKEN)

    this.user = (
      await axios.get(`https://api.github.com/users/${this.username}`, {
        headers: {
          Authorization: `token ${token}`,
        },
      })
    ).data

    this.orgs = (
      await axios.get(`https://api.github.com/users/${this.username}/orgs`, {
        headers: {
          Authorization: `token ${token}`,
        },
      })
    ).data

    document.title = `Shin | ${this.user.name}`
  },
})
